import { Helmet } from 'react-helmet-async';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-slate-950">
      <Helmet>
        <title>Privacy Policy | SquareCount</title>
        <meta name="description" content="SquareCount privacy policy. Learn how we protect your data and handle information for our roof measurement software." />
        <link rel="canonical" href="https://squarecount.io/privacy" />
        <meta name="robots" content="noindex" />
      </Helmet>
      <Navbar />

      <section className="bg-gradient-to-br from-slate-900 via-slate-800 to-orange-900 text-white py-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="font-heading font-black text-4xl sm:text-5xl mb-4">Privacy Policy</h1>
          <p className="text-slate-300">Last updated: February 8, 2026</p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 py-16">
        <div className="prose prose-lg prose-invert max-w-none">
          <h2 className="font-heading font-bold text-2xl text-white">1. Information We Collect</h2>
          <p className="text-slate-300">We collect information you provide directly to us, including:</p>
          <ul className="text-slate-300">
            <li><strong className="text-white">Account Information:</strong> Name, email address, password</li>
            <li><strong className="text-white">Usage Data:</strong> Measurements, reports, subscription tier</li>
            <li><strong className="text-white">Payment Information:</strong> Processed securely through Stripe</li>
            <li><strong className="text-white">Technical Data:</strong> IP address, browser type, device information</li>
          </ul>

          <h2 className="font-heading font-bold text-2xl text-white mt-8">2. How We Use Your Information</h2>
          <p className="text-slate-300">We use the information we collect to:</p>
          <ul className="text-slate-300">
            <li>Provide and improve our services</li>
            <li>Process your measurements and generate reports</li>
            <li>Communicate with you about your account</li>
            <li>Process payments and prevent fraud</li>
            <li>Send you technical notices and updates</li>
          </ul>

          <h2 className="font-heading font-bold text-2xl text-white mt-8">3. Information Sharing</h2>
          <p className="text-slate-300">We do not sell your personal information. We may share your information with:</p>
          <ul className="text-slate-300">
            <li><strong className="text-white">Service Providers:</strong> Stripe for payments, cloud hosting providers</li>
            <li><strong className="text-white">Legal Requirements:</strong> When required by law or to protect our rights</li>
            <li><strong className="text-white">Business Transfers:</strong> In connection with a merger or acquisition</li>
          </ul>

          <h2 className="font-heading font-bold text-2xl text-white mt-8">4. Data Security</h2>
          <p className="text-slate-300">We implement appropriate technical and organizational measures to protect your data, including:</p>
          <ul className="text-slate-300">
            <li>Encryption in transit and at rest</li>
            <li>Secure authentication</li>
            <li>Regular security assessments</li>
            <li>Access controls and monitoring</li>
          </ul>

          <h2 className="font-heading font-bold text-2xl text-white mt-8">5. Your Rights</h2>
          <p className="text-slate-300">You have the right to:</p>
          <ul className="text-slate-300">
            <li>Access your personal data</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Export your data</li>
            <li>Opt-out of marketing communications</li>
          </ul>

          <h2 className="font-heading font-bold text-2xl text-white mt-8">6. Cookies</h2>
          <p className="text-slate-300">We use cookies and similar technologies to:</p>
          <ul className="text-slate-300">
            <li>Keep you signed in</li>
            <li>Remember your preferences</li>
            <li>Analyze site usage with Google Analytics</li>
          </ul>

          <h2 className="font-heading font-bold text-2xl text-white mt-8">7. Contact Us</h2>
          <p className="text-slate-300">If you have questions about this Privacy Policy, please contact us at:</p>
          <p className="text-slate-300"><strong className="text-white">Email:</strong> privacy@squarecount.io</p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
